import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import moment from "moment";
import axios from "axios";
import "./calendar.css";
import { connect } from "react-redux";
import {priceFormatter,CURRENCY_SYMBOLS} from '../../../helpers/general.helper'

function MyCalendar(props) {


const handleChange=(data)=>{
  props.onChange(data)
}


  return (
    <div>
        <Calendar
          onChange={handleChange}
          value={props.value}
          locale={"en-US"}
          selectRange
          showDoubleView
          showNeighboringMonth    
          minDate={props.minDate}
          defaultActiveStartDate={props.value.length&&props.value[0]} 
        />
    
    </div>
  );
}
// export default MyCalendar;

const mapStateWithProps = (state) => ({
  currency:state.flight.currency?state.flight.currency:"",
});

export default React.memo(connect(mapStateWithProps)(MyCalendar));
MyCalendar.defaultProps = {
  query: "",
  defaultDate: new Date(),
  minDate: new Date(),
   showTwoMonths:false,
  showRange: false,
};


